import React, { useState, useEffect } from 'react'
import { usePageContext } from 'pageContext'
import { ToggleSwitch, Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
const WithoutApprovalFilter = (props) => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()
    const { withoutApproval: preWithoutApproval } = state
    const [withoutApproval, setwithoutApproval] = useState(preWithoutApproval)

    const changeSelection = () => {
        dispatch({
            type: 'SET_PROP',
            payload: {
                key: 'withoutApproval',
                value: withoutApproval,
            },
        })
    }

    useEffect(() => {
        changeSelection()
    }, [withoutApproval])

    const content = () => {
        return (
            <>
                <Box padding="0px 20px 0px 20px">
                    <ToggleSwitch
                        onChange={() => {
                            setwithoutApproval((prev) => !prev)
                        }}
                        value={withoutApproval}
                        label={'On'}
                    />
                </Box>
            </>
        )
    }

    return (
        <Card
            cardTitle={t('WithoutApproval')}
            color="#fff"
            collapsible
            expanded={withoutApproval}
        >
            {content()}
        </Card>
    )
    // TODO: Need to Enable it for Mobile UI
    // return isSmallScreen ? (
    //     <Accordion
    //         expanded={true}
    //         title={!title ? t('Common_TargetPerson') : title}
    //         disabled={applicationId}
    //     >
    //         <Box padding="20px 0px">{content()}</Box>
    //     </Accordion>
    // ) : (

    //     <Card
    //         cardTitle={!title ? t('Common_TargetPerson') : title}
    //         color="#fff"
    //         collapsible
    //         expanded={true}
    //         disabled={applicationId}
    //     >
    //         {content()}
    //     </Card>
    // )
}

export default WithoutApprovalFilter
